import { styled, css } from 'styled-components';
export const Wrapper = styled.label `
  display: ${({ $inline }) => ($inline ? 'inline-flex' : 'flex')};
  align-items: center;
  gap: 5px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  padding-top: ${({ $pseudoLabel }) => ($pseudoLabel ? '32px' : '8px')};
  padding-bottom: 8px;
`;
export const Text = styled.span `
  ${({ theme, disabled }) => css `
    color: ${disabled ? theme.colors.grey100_2 : theme.colors.black_1};
    ${theme.typography.textMedium}
    ${theme.typography.weightMedium}
  `}
  display: flex;
  align-items: center;
  gap: 4px;
`;
export const Slider = styled.span `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ theme }) => theme.colors.grey30_1};
  transition: 0.4s;
  border-radius: 9999px;
  &:before {
    border-radius: 9999px;
    position: absolute;
    content: '';
    height: 14px;
    width: 14px;
    left: 4px;
    bottom: 3px;
    background-color: ${({ theme }) => theme.colors.grey00_1};
    transition: 0.4s;
  }

  &:focus {
    ${({ theme }) => theme.shadows.focus};
  }
`;
export const SwitchWrapper = styled.span `
  position: relative;
  display: inline-block;
  width: 36px;
  height: 20px;
  & input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  & input:checked:not(:disabled) + ${Slider} {
    background-color: ${({ theme }) => theme.colors.main};
  }

  & input:focus + ${Slider} {
    ${({ theme }) => theme.shadows.focus};
  }

  & input:disabled + ${Slider} {
    background-color: ${({ theme }) => theme.colors.grey10_1};
  }

  & input:disabled + ${Slider}:before {
    background-color: ${({ theme }) => theme.colors.grey01_1};
  }

  & input:checked + ${Slider}:before {
    transform: translateX(14px);
  }
`;
